export enum PaCathegoryEnum
{
    noAdditionalRisk = 1, // #65B4BA
    hypertension = 2, // #F79F8F
    borderline = 3, //
}